<template>
  <DashboardHeader>
    <CrudTables :tables="tables"></CrudTables>
  </DashboardHeader>
</template>

<script>
import DashboardHeader from "@/components/DashboardHeader.vue";
import CrudTables from "@/components/myLibrary/CrudTables.vue";
export default {
  components: { DashboardHeader, CrudTables },

  data() {
    return {
      tables: [
        {
          text: "Company",
          value: "companies",
          alevel: [7, 8, 9, 10, 11, 12, 13, 14, 15],
        },
        {
          text: "Company Profile",
          value: "company_profile",
          alevel: [7, 8, 9, 10, 11, 12, 13, 14, 15],
        },

        {
          text: "Site Settings",
          value: "site_settings",
          alevel: [7, 8, 9, 10, 11, 12, 13, 14, 15],
        },
      ],
    };
  },
};
</script>

<style></style>
